module.exports = __webpack_public_path__ + "img/aboutus.d1849ebc.jpg";